module.exports = __webpack_public_path__ + "static/media/campaign-splash.2765e0ff.JPG";